const TOKEN_KEY = 'cm_auth_token';
const USER_KEY = 'cm_auth_user';

export interface AuthUser {
  id: string;
  telegram_id: number;
  telegram_username: string | null;
  display_name: string;
  avatar_url: string | null;
  role: string;
  status: string;
  rating: number;
  rating_count: number;
  auctions_sold: number;
  created_at: string;
}

export const authStorage = {
  getToken(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },

  setToken(token: string): void {
    try {
      localStorage.setItem(TOKEN_KEY, token);
    } catch {
      // localStorage недоступен (приватный режим и т.п.) — игнорируем
    }
  },

  getUser(): AuthUser | null {
    try {
      const raw = localStorage.getItem(USER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },

  setUser(user: AuthUser): void {
    try {
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    } catch {}
  },

  clear(): void {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    } catch {}
  },
};